import { useSelector } from 'react-redux'

import { eventTypeSelector, useGetFeaturesQuery } from 'root-api'
import { useProfile } from 'components/use_profile'
import { useEventType } from 'components/use_event_type'
import { useLandingPage } from 'components/use_landing_page'
import { useRoutingForm } from 'components/use_routing_form'


const useOrgUuidFromProfile = () => {
  const profile = useProfile()

  if (profile === undefined) return undefined
  if (profile === null) return null
  return profile.organization_uuid
}

const useOrgUuidFromEventType = () => {
  const eventType = useEventType()

  if (eventType === undefined) return undefined
  if (eventType === null) return null
  return eventType.organization.uuid
}

const useOrgUuidFromLandingPage = () => {
  const landingPage = useLandingPage()

  if (landingPage === undefined) return undefined
  if (landingPage === null) return null

  return landingPage.organization_uuid
}

const useOrgUuidFromRoutingForm = () => {
  const routingForm = useRoutingForm()

  if (routingForm === undefined) return undefined
  if (routingForm === null) return null

  return routingForm.organization.uuid
}

export const useOrganizationUuid = () => {
  const uuidFromEventType = useOrgUuidFromEventType()
  const uuidFromProfile = useOrgUuidFromProfile()
  const uuidFromLandingPage = useOrgUuidFromLandingPage()
  const uuidFromRoutingForm = useOrgUuidFromRoutingForm()

  if (uuidFromEventType) return uuidFromEventType
  if (uuidFromProfile) return uuidFromProfile
  if (uuidFromLandingPage) return uuidFromLandingPage
  if (uuidFromRoutingForm) return uuidFromRoutingForm

  const allValues = [uuidFromEventType, uuidFromProfile, uuidFromLandingPage, uuidFromRoutingForm]

  if (allValues.some((value) => value === undefined)) return undefined

  return null
}

export const useFeatures = () => {
  const uuid = useOrganizationUuid()
  return useGetFeaturesQuery({ uuid }, { skip: !uuid })
}

export const useOrganizationLogoUrl = () => {
  const eventTypeData = useSelector(eventTypeSelector) || {}

  return eventTypeData?.organization?.logo_url ?? null
}
